export const appShape = {
	surfaceRadius: '12px',
	controlRadius: '6px',
	controlGroupRadius: '8px',
} as const;
